var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLuckycoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58118 0 0 3.58118 0 8C0 12.4188 3.58118 16 8 16C12.4188 16 16 12.4188 16 8C16 3.58118 12.4188 0 8 0ZM9.41177 9.41177H6.58824V6.58824H9.41177V9.41177Z",
    fill: "#FBE76A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00023 0.941162C4.10376 0.941162 0.941406 4.10352 0.941406 7.99999C0.941406 11.8965 4.10376 15.0588 8.00023 15.0588C11.8967 15.0588 15.0591 11.8965 15.0591 7.99999C15.0591 4.10352 11.8967 0.941162 8.00023 0.941162ZM9.41199 9.41175H6.58847V6.58822H9.41199V9.41175Z",
    fill: "#F8D707"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94095 2.35291H7.05859V4.23526H8.94095V2.35291Z",
    fill: "#DFC206"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94095 11.7646H7.05859V13.647H8.94095V11.7646Z",
    fill: "#DFC206"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23587 7.05884H2.35352V8.94119H4.23587V7.05884Z",
    fill: "#DFC206"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.648 7.05884H11.7656V8.94119H13.648V7.05884Z",
    fill: "#DFC206"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64648 5.64709V10.353H10.3524V5.64709H5.64648ZM9.41119 9.4118H6.58766V6.58827H9.41119V9.4118Z",
    fill: "#FBE76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuckycoins);
export default __webpack_public_path__ + "static/media/luckycoins.313f079b40e4919d8100021a0e265236.svg";
export { ForwardRef as ReactComponent };